import { render, staticRenderFns } from "./form-document-rename.vue?vue&type=template&id=724903fc&scoped=true&lang=pug"
import script from "./form-document-rename.vue?vue&type=script&lang=js"
export * from "./form-document-rename.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "724903fc",
  null
  
)

export default component.exports